import type { AfterViewInit } from '@angular/core';
import { Directive, TemplateRef, ViewContainerRef, Renderer2, inject } from '@angular/core';

@Directive({
  selector: '[appFadeInOnScroll]',
  standalone: true,
})
export class FadeInOnScrollDirective implements AfterViewInit {
  readonly #templateRef = inject(TemplateRef<unknown>);
  readonly #viewContainer = inject(ViewContainerRef);
  readonly #renderer = inject(Renderer2);

  ngAfterViewInit(): void {
    const embeddedView = this.#viewContainer.createEmbeddedView(this.#templateRef);
    const element = embeddedView.rootNodes[0];

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          this.#renderer.removeClass(element, 'fadeInit');
          observer.unobserve(element);
        }
      },
      { threshold: 0.1 },
    );

    observer.observe(element);
  }
}
